export default "__VITE_ASSET__fOOaE715__"